/* Sunday Article — reading enhancements for blog posts:
   1. Auto-generated table of contents + scroll-spy (from h2/h3).
   2. Citations: inline [N] markers become superscript links to a boxed
      reference list with back-links, and hovering a citation previews the
      reference text in a tooltip.
   All features degrade gracefully and never double-process posts that
   already ship their own anchored citation markup. */
(function () {
  'use strict';

  function slugify(text) {
    return (
      text
        .trim()
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60) || 'section'
    );
  }

  /* ----------------------------------------------------------------------
     Table of contents
     ---------------------------------------------------------------------- */
  function initToc(content) {
    var toc = document.querySelector('[data-article-toc]');
    var list = document.querySelector('[data-article-toc-list]');
    if (!toc || !list) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));
    if (headings.length < 2) {
      toc.hidden = true;
      var layout = toc.closest('.sunday-article__layout');
      if (layout) layout.classList.remove('sunday-article__layout--with-toc');
      return;
    }

    var used = Object.create(null);
    var links = Object.create(null);

    headings.forEach(function (heading) {
      var base = heading.id || slugify(heading.textContent);
      var id = base;
      var n = 2;
      while (used[id]) id = base + '-' + n++;
      used[id] = true;
      heading.id = id;

      var li = document.createElement('li');
      li.className =
        'sunday-article__toc-item sunday-article__toc-item--' + heading.tagName.toLowerCase();

      var a = document.createElement('a');
      a.className = 'sunday-article__toc-link';
      a.href = '#' + id;
      a.textContent = heading.textContent.trim();
      a.setAttribute('data-toc-link', id);

      li.appendChild(a);
      list.appendChild(li);
      links[id] = a;
    });

    var activeId = null;
    function setActive(id) {
      if (id === activeId || !links[id]) return;
      if (activeId && links[activeId]) links[activeId].classList.remove('is-active');
      links[id].classList.add('is-active');
      activeId = id;
    }

    var visible = Object.create(null);
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) visible[entry.target.id] = true;
            else delete visible[entry.target.id];
          });
          var current = null;
          for (var i = 0; i < headings.length; i++) {
            if (visible[headings[i].id]) current = headings[i].id;
          }
          if (!current) {
            for (var j = 0; j < headings.length; j++) {
              if (headings[j].getBoundingClientRect().top < 140) current = headings[j].id;
            }
          }
          if (current) setActive(current);
        },
        { rootMargin: '-130px 0px -65% 0px', threshold: 0 }
      );
      headings.forEach(function (h) {
        observer.observe(h);
      });
    }

    list.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-toc-link]');
      if (!link) return;
      setActive(link.getAttribute('data-toc-link'));
      if (window.matchMedia('(max-width: 989px)').matches && toc.tagName === 'DETAILS') {
        toc.open = false;
      }
    });

    setActive(headings[0].id);
  }

  /* ----------------------------------------------------------------------
     Citations & references
     ---------------------------------------------------------------------- */
  var URL_RE = /(https?:\/\/[^\s)]+)/g;
  var HEADING_RE = /^\s*(references|sources|citations|bibliography|footnotes)\b/i;

  function linkifyUrls(text) {
    var frag = document.createDocumentFragment();
    var last = 0;
    var m;
    URL_RE.lastIndex = 0;
    while ((m = URL_RE.exec(text))) {
      if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      var href = m[0].replace(/[.,;]+$/, '');
      var trailing = m[0].slice(href.length);
      var a = document.createElement('a');
      a.className = 'sunday-article__ref-link';
      a.href = href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = href;
      frag.appendChild(a);
      if (trailing) frag.appendChild(document.createTextNode(trailing));
      last = m.index + m[0].length;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    return frag;
  }

  function findRefHeading(content) {
    var hs = content.querySelectorAll('h1, h2, h3, h4, h5, h6');
    for (var i = 0; i < hs.length; i++) {
      if (HEADING_RE.test(hs[i].textContent)) return hs[i];
    }
    return null;
  }

  // Wrap the references region (heading + entries, or a `.references` block)
  // in a single boxed panel.
  function buildRefsPanel(refHeading, refContainer) {
    if (!refHeading) {
      if (refContainer) {
        refContainer.classList.add('sunday-article__refs');
        return refContainer;
      }
      return null;
    }
    var panel = document.createElement('div');
    panel.className = 'sunday-article__refs';
    refHeading.parentNode.insertBefore(panel, refHeading);
    var collected = [];
    var node = refHeading;
    while (node) {
      if (node !== refHeading && /^H[1-6]$/.test(node.tagName)) break;
      collected.push(node);
      node = node.nextElementSibling;
    }
    collected.forEach(function (n) {
      panel.appendChild(n);
    });
    return panel;
  }

  // Turn plain-text [N] markers into links + format the reference list.
  // Only called for posts that DON'T already ship anchored citations.
  function autoLinkCitations(content, panel) {
    var refMap = Object.create(null);
    var refs = [];
    function register(el, num) {
      if (refMap[num]) return;
      el.id = 'ref-' + num;
      el.classList.add('sunday-article__ref-item');
      refMap[num] = el;
      refs.push({ el: el, num: num });
    }

    Array.prototype.forEach.call(panel.children, function (el) {
      var tag = el.tagName;
      if (/^H[1-6]$/.test(tag)) return;
      if (tag === 'OL' || tag === 'UL') {
        var seq = 1;
        Array.prototype.forEach.call(el.children, function (li) {
          var lm = li.textContent.match(/^\s*\[(\d+)\]/);
          register(li, lm ? lm[1] : String(seq));
          seq++;
        });
        el.classList.add('sunday-article__ref-list');
      } else if (tag === 'P' || tag === 'LI' || tag === 'DIV') {
        var pm = el.textContent.match(/^\s*\[(\d+)\]/);
        if (pm) register(el, pm[1]);
      }
    });
    if (!refs.length) return;

    var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    while (walker.nextNode()) {
      var tn = walker.currentNode;
      if (panel.contains(tn)) continue;
      if (/\[\d+(?:\s*,\s*\d+)*\]/.test(tn.nodeValue)) textNodes.push(tn);
    }

    var seen = Object.create(null);
    var marker = /\[(\d+(?:\s*,\s*\d+)*)\]/g;
    textNodes.forEach(function (textNode) {
      var str = textNode.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      var m;
      marker.lastIndex = 0;
      while ((m = marker.exec(str))) {
        if (m.index > last) frag.appendChild(document.createTextNode(str.slice(last, m.index)));
        var nums = m[1].split(',').map(function (s) {
          return s.trim();
        });
        var group = document.createElement('sup');
        group.className = 'sunday-article__cite-group';
        group.appendChild(document.createTextNode('['));
        var resolved = 0;
        nums.forEach(function (num, idx) {
          if (idx > 0) group.appendChild(document.createTextNode(', '));
          if (refMap[num]) {
            resolved++;
            var a = document.createElement('a');
            a.className = 'sunday-article__cite';
            a.href = '#ref-' + num;
            a.textContent = num;
            if (!seen[num]) {
              a.id = 'cite-' + num;
              seen[num] = true;
            }
            group.appendChild(a);
          } else {
            group.appendChild(document.createTextNode(num));
          }
        });
        group.appendChild(document.createTextNode(']'));
        if (resolved) frag.appendChild(group);
        else frag.appendChild(document.createTextNode(m[0]));
        last = m.index + m[0].length;
      }
      if (last < str.length) frag.appendChild(document.createTextNode(str.slice(last)));
      textNode.parentNode.replaceChild(frag, textNode);
    });

    refs.forEach(function (ref) {
      var rest = ref.el.textContent.replace(/^\s*\[\d+\]\s*/, '');
      var numEl = document.createElement('span');
      numEl.className = 'sunday-article__ref-num';
      numEl.textContent = ref.num;

      var body = document.createElement('div');
      body.className = 'sunday-article__ref-body';
      body.appendChild(linkifyUrls(rest));

      if (seen[ref.num]) {
        body.appendChild(document.createTextNode(' '));
        var back = document.createElement('a');
        back.className = 'sunday-article__ref-back';
        back.href = '#cite-' + ref.num;
        back.setAttribute('aria-label', 'Back to reference ' + ref.num + ' in the text');
        back.textContent = '↩';
        body.appendChild(back);
      }

      ref.el.textContent = '';
      ref.el.appendChild(numEl);
      ref.el.appendChild(body);
    });
  }

  // Hover/focus a citation to preview its reference text.
  function attachTooltips(content) {
    var cites = Array.prototype.slice.call(content.querySelectorAll('a[href^="#ref"]'));
    if (!cites.length) return;

    var tip = document.createElement('div');
    tip.className = 'sunday-article__tooltip';
    tip.setAttribute('role', 'tooltip');
    document.body.appendChild(tip);
    var hideTimer = null;

    function refText(targetId) {
      var t = document.getElementById(targetId);
      if (!t) return null;
      var raw = t.textContent.replace(/↩/g, ' ').replace(/\s+/g, ' ').trim();
      return raw.replace(/^\[?\d+\]?[.)]?\s*/, '');
    }

    function show(link) {
      var id = link.getAttribute('href').slice(1);
      var text = refText(id);
      if (!text) return;
      var num = (id.match(/\d+/) || [''])[0];
      tip.innerHTML = '';
      if (num) {
        var badge = document.createElement('span');
        badge.className = 'sunday-article__tooltip-num';
        badge.textContent = num;
        tip.appendChild(badge);
      }
      tip.appendChild(document.createTextNode(text));
      tip.classList.add('is-visible');

      var r = link.getBoundingClientRect();
      var tw = tip.offsetWidth;
      var th = tip.offsetHeight;
      var left = Math.max(12, Math.min(r.left + r.width / 2 - tw / 2, window.innerWidth - tw - 12));
      var top = r.top - th - 10;
      if (top < 12) top = r.bottom + 10;
      tip.style.left = left + 'px';
      tip.style.top = top + 'px';
    }

    function hide() {
      tip.classList.remove('is-visible');
    }

    cites.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        if (hideTimer) clearTimeout(hideTimer);
        show(link);
      });
      link.addEventListener('mouseleave', function () {
        hideTimer = setTimeout(hide, 80);
      });
      link.addEventListener('focus', function () {
        show(link);
      });
      link.addEventListener('blur', hide);
    });
  }

  // Smooth-scroll + brief highlight for citation / back-link jumps.
  function attachJumpScroll(content) {
    content.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#ref"], a[href^="#cite"]');
      if (!link || !content.contains(link)) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
      target.classList.add('is-flash');
      setTimeout(function () {
        target.classList.remove('is-flash');
      }, 1600);
    });
  }

  function initCitations(content) {
    var refHeading = findRefHeading(content);
    var refContainer = content.querySelector('.references, [class*="reference"]');
    if (!refHeading && !refContainer) return;

    // Posts may already ship anchored citations — never double-process those.
    var preLinked = !!content.querySelector('a[href^="#ref"], a[href^="#cite"]');

    var panel = buildRefsPanel(refHeading, refContainer);
    if (!preLinked && refHeading && panel) {
      autoLinkCitations(content, panel);
    }

    attachTooltips(content);
    attachJumpScroll(content);
  }

  function init() {
    var content = document.querySelector('[data-article-content]');
    if (!content) return;
    initToc(content);
    initCitations(content);
  }

  // Copy-link share button (delegated; works regardless of the TOC).
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-share-copy]');
    if (!btn) return;
    event.preventDefault();
    var url = btn.getAttribute('data-share-url') || window.location.href;
    var done = function () {
      var feedback = btn.parentNode.querySelector('[data-share-feedback]');
      if (!feedback) return;
      feedback.classList.add('is-visible');
      setTimeout(function () {
        feedback.classList.remove('is-visible');
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () {});
    } else {
      var tmp = document.createElement('textarea');
      tmp.value = url;
      document.body.appendChild(tmp);
      tmp.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {}
      document.body.removeChild(tmp);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
